import { Icon } from './Icon';

export function Logo({ small }: { small?: boolean }) {
  return (
    <span className={`logo ${small ? 'is-small' : ''}`}>
      <span className="logo-mark">
        <Icon name="bolt" size={small ? 16 : 22} />
      </span>
      <span className="logo-text">
        AllAware <b>Play</b>
      </span>
    </span>
  );
}
